import { render, staticRenderFns } from "./Contenido.vue?vue&type=template&id=bde83372"
import script from "./Contenido.vue?vue&type=script&lang=js"
export * from "./Contenido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports